import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import React from 'react';
import { FieldArray } from 'redux-form';
import useTranslate from 'application/hooks/use-translate';
import DefaultDateValueField from '../../../components/Form/DefaultDateValueField/DefaultDateValueField';
import { NumberField, SelectorField } from '../../../components/Form/Fields';
import SpacedFormElement from '../../../components/Form/SpacedFormElement/SpacedFormElement';
import AdditionalTransportFees from '../AdditionalTransportFees';
import { LINE_SPECIFIC_POSSIBLE_CONTEXT_ELEMENTS, TRANSPORT_TYPES_LIST } from '../constants';
import FeeBox from '../FeeBox';
import RestrictedAdditionalTransportContextElement from '../RestrictedAdditionalTransportContextElement';
import { selectStartDate } from '../selectors';

function TransportFee({ fieldName, fieldIndex, fields }) {
  const translate = useTranslate();
  return (
    <FeeBox fieldIndex={fieldIndex} fields={fields} label={translate('travel-expenses.transportation')}>
      <Grid container style={{ padding: 16 }}>
        <Grid item xs={12} sm={6}>
          <SpacedFormElement
            name={`${fieldName}.date`}
            label={translate('act.date')}
            component={DefaultDateValueField}
            dateSelector={selectStartDate}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SpacedFormElement
            name={`${fieldName}.transportType`}
            label={translate('travel-expenses.transportation-type')}
            component={SelectorField}
            formControlProps={{ fullWidth: true }}
            values={TRANSPORT_TYPES_LIST}
          />
        </Grid>

        <Grid item xs={12} sm={6}>
          <SpacedFormElement
            name={`${fieldName}.goingKilometers`}
            label={translate('travel-expenses.nb-km-one-way')}
            component={NumberField}
          />
        </Grid>
      </Grid>
      <FieldArray name={`${fieldName}.additionalTransportFees`} component={AdditionalTransportFees} />
      <RestrictedAdditionalTransportContextElement
        fieldName={fieldName}
        label="E. Contexte (ligne spécifique)"
        list={LINE_SPECIFIC_POSSIBLE_CONTEXT_ELEMENTS}
      />
    </FeeBox>
  );
}

TransportFee.propTypes = {
  fieldIndex: PropTypes.number.isRequired,
  fieldName: PropTypes.string.isRequired,
  fields: PropTypes.object.isRequired
};

export default TransportFee;
